module.exports = __webpack_public_path__ + "static/img/2.ca84600.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/2.png
// module id = uhs5
// module chunks = 0